export function jobsPinpoint() {
    $('#jobs-pinpoint-listing').on('click', '.jobs-list-container', function () {
        var _url = $(this).data('url');
        window.open(_url);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/jobs-pinpoint.js